export default function Story() {
return (
    <section className="py-20 ">
        <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-gray-50 px-10 py-10 rounded-xl">
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-4">
            Your Future Depends on First Impressions — InterviewAdvantage Makes Them Count
        </h1>
        <p className="text-lg pb-4">
        You're talented, hardworking, and ready to take the next step in your career. But if you’re struggling to find a new job, sending out dozens of resumes with no response, or interviewing without landing offers, the frustration can feel overwhelming.
        </p>
        <p className="text-lg pb-4">
        You might be second-guessing your preparation, unsure why hiring managers aren’t calling you back, or wondering if your interview answers are falling flat. It’s discouraging when you know you have the skills but aren’t seeing the results you deserve. </p>

        <p className="text-lg pb-4">
Enter InterviewAdvantage.ai, by ArcAdvantage.
        </p>
        <p className="text-lg pb-4">
        InterviewAdvantage.ai combines insights from <b>over 5,000 coaching sessions</b> and conversations with more than <b>15,000 hiring managers</b> to deliver AI-driven, customized interview preparation. Our platform helps you craft compelling answers, anticipate tricky questions, and showcase your unique strengths with confidence. </p>
        <p className="text-lg pb-4">
        Whether you need to fine-tune your resume, ace your next interview, or turn interviews into offers, InterviewAdvantage.ai provides the expert guidance you need to stand out.</p>
        <p className="text-lg pb-4">
        The result? Confidence in every interview, clarity in your communication, and the competitive edge to finally land your dream job.
        </p>
        <p className="text-lg pb-4">
        Your career deserves more than guesswork. Use InterviewAdvantage to turn opportunities into offers and achieve the success you’ve worked so hard for.
        </p>
        </div>
        </div>
    </section>
  )
}